import React from 'react';

const SuccessModal = ({ trigger, countdown, description, cta_text, title }) => {
    return (
        <div id="success-modal" tabIndex="-1" className="fixed top-0 left-0 right-0 bottom-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[100%] max-h-full bg-black-overlay flex justify-center items-center">
            <div className="relative w-full max-w-lg max-h-full">
                <div className="relative bg-white rounded-lg shadow">
                    <div className="flex items-start justify-between p-4 rounded-t bg-success mb-2">
                        <h1 className="text-2xl font-bold leading-tight tracking-tight text-white md:text-2xl text-center">
                        { title }
                        </h1>
                        <button type="button" className="bg-transparent rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center" onClick={() => trigger(false)}>
                        <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span className="sr-only">Close modal</span>
                        </button>
                    </div>
                    <div className="p-6 text-center">
                        <h3 className="mb-5 text-lg font-normal text-black ">{ description }</h3>
                        <button className='text-white bg-primary hover:bg-primary focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center' onClick={() => {
                            trigger(false);
                        }}>{ cta_text }</button>
                        <p className="mt-5 text-md font-normal text-gray-2 ">Close in {countdown} seconds</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessModal;